function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#174ABC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1767 9.87759C21.9804 9.13853 21.4021 8.55647 20.6678 8.35894C19.3369 8 14 8 14 8C14 8 8.66312 8 7.33216 8.35894C6.59787 8.5565 6.01956 9.13853 5.82328 9.87759C5.46666 11.2172 5.46666 14.0121 5.46666 14.0121C5.46666 14.0121 5.46666 16.8071 5.82328 18.1467C6.01956 18.8857 6.59787 19.4435 7.33216 19.6411C8.66312 20 14 20 14 20C14 20 19.3369 20 20.6678 19.6411C21.4021 19.4435 21.9804 18.8857 22.1767 18.1467C22.5333 16.8071 22.5333 14.0121 22.5333 14.0121C22.5333 14.0121 22.5333 11.2172 22.1767 9.87759ZM12.2545 16.5497V11.4745L16.7151 14.0122L12.2545 16.5497Z",
  fill: "white"
});

function SvgFooterIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon6);
export default __webpack_public_path__ + "static/media/footer_icon6.c0be1939.svg";
export { ForwardRef as ReactComponent };